<template>
  <div class="wrapper">
    <img src="~assets/img/锥形框.png" alt="" />
    <div class="detailName">{{rawMaterial}}</div>
  </div>
</template>
<script>
export default {
  name: "cone",
  props:{
      rawMaterial:{
          type:String,
      }
  }
};
</script>
<style scoped>
.wrapper {
    width: 50px;
    height: 90px;
    position: relative;
}
.wrapper img {
    width: 40px;
    height: 90px;
}
.detailName {
    width: 25px;
    height: 40px;
    color: rgb(250, 248, 248);
    position: absolute;
    top: 10px;
    left: 12px;
    font-size: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/detailModule/cone.vue